export default class Configuration {
    constructor (
        _code = 1, 
        _name = "",
        _value = ""
    ){
        
        this.code = _code; 
        this.name = _name;
        this.value = _value;
    }
}
  